import { createSlice } from "@reduxjs/toolkit";

export const initialState = {};

export const cacheSlice = createSlice({
	name: "cache",
	initialState,
	reducers: {
		setCache: (state, action) => {
			Object.keys(action.payload).forEach((key) => {
				if(action.payload[key] !== undefined){
					state[key] = action.payload[key];
				} else {
					delete state[key];
				}
			});
		},
		cleanCache: (state) => {
			const stateKeys = [...Object.keys(state)];
			stateKeys.forEach((key) => {
				delete state[key];
			});
		},
	},
});

export const { setCache, cleanCache } = cacheSlice.actions;

export default cacheSlice.reducer;
